module.exports = __webpack_public_path__ + "img/taiwan.9d49dfba.svg";